// import { ListViewProvider, useListView } from '../core/ListViewProvider'
// import { QueryRequestProvider } from '../core/QueryRequestProvider'
// import { QueryResponseProvider } from '../core/QueryResponseProvider'
// import { UsersListHeader } from '../components/header/UsersListHeader'
// import { UsersTable } from '../table/UsersTable'
// import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
// import { KTCard } from '../../../../../../_metronic/helpers'
// import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
// import { roleColumns } from './_columns'
// import { useAuth } from '../../../../auth'
// import { useState } from 'react'

// const mockedData = [
//   {
//     gender: 'Male',
//     email: 'ashok@gmail.com',
//     fullAddress: 'New Baneshwor, Kathmandu',
//     mobile: '9860105561',
//     joinDate: '2023/09/05',
//     currentLevel: 'Manager',
//     pointEarned: 45,
//     pointRedeemed: 5,
//     name: 'Ashok Karki',
//     birthday: '1992/12/22',
//   },
//   {
//     gender: 'Femal',
//     email: 'aleshika@gmail.com',
//     fullAddress: 'Old Baneshwor, Kathmandu',
//     mobile: '9860105560',
//     joinDate: '2023/09/06',
//     currentLevel: 'Employee',
//     pointEarned: 5,
//     pointRedeemed: 15,
//     name: 'Aleshki Chheri',
//     birthday: '1996/06/06',
//   },
// ]

// const SearchIcon = () => (
//   <svg
//     width='16'
//     height='16'
//     viewBox='0 0 24 24'
//     fill='none'
//     stroke='currentColor'
//     strokeWidth='2'
//     strokeLinecap='round'
//     strokeLinejoin='round'
//     style={{
//       position: 'absolute',
//       left: '10px',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       color: '#6B7280',
//     }}
//   >
//     <circle cx='11' cy='11' r='8' />
//     <line x1='21' y1='21' x2='16.65' y2='16.65' />
//   </svg>
// )

// const UserManagementList = () => {

//   const [searchQuery, setSearchQuery] = useState('')
//   const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const query = e.target.value.toLowerCase()
//     setSearchQuery(query)

//     // Get all table rows
//     const tableRows = document.querySelectorAll('table tbody tr') as NodeListOf<HTMLTableRowElement>

//     // Loop through each row
//     tableRows.forEach((row: HTMLTableRowElement) => {
//       const cells = row.querySelectorAll('td') as NodeListOf<HTMLTableCellElement>
//       let found = false

//       // Check each cell in the row
//       cells.forEach((cell: HTMLTableCellElement) => {
//         const text = cell.textContent?.toLowerCase() || ''
//         if (text.includes(query)) {
//           found = true
//         }
//       })

//       // Show/hide row based on search match
//       if (found) {
//         row.style.display = ''
//       } else {
//         row.style.display = 'none'
//       }
//     })
//   }
//   const { isFranchise, isPartner, isSupplyChainManager } = useAuth()
//   return (
//     <KTCard>
//       {/* <div
//         style={{
//           position: 'relative',
//           width: '300px',
//           marginLeft: '30px',
//           marginBottom: '-30px',
//         }}
//       >
//         <SearchIcon />
//         <input
//           type='text'
//           placeholder='Search users...'
//           value={searchQuery}
//           onChange={handleSearch}
//           style={{
//             width: '100%',
//             height: '40px',
//             padding: '8px 8px 8px 35px',
//             fontSize: '14px',
//             border: '1px solid #E5E7EB',
//             borderRadius: '6px',
//             outline: 'none',
//             backgroundColor: 'white',
//             transition: 'border-color 0.2s ease',
//           }}
//           onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
//           onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
//         />
//       </div>
//       {!isPartner && <UsersListHeader label='Add new' />} */}

//       <div style={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         padding: "10px 30px"
//       }}>
//         <div
//           style={{
//             position: 'relative',
//             width: '300px',
//           }}
//         >
//           <SearchIcon />
//           <input
//             type='text'
//             placeholder='Search users...'
//             value={searchQuery}
//             onChange={handleSearch}
//             style={{
//               width: '100%',
//               height: '40px',
//               padding: '8px 8px 8px 35px',
//               fontSize: '14px',
//               border: '1px solid #E5E7EB',
//               borderRadius: '6px',
//               outline: 'none',
//               backgroundColor: 'white',
//               transition: 'border-color 0.2s ease',
//             }}
//             onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
//             onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
//           />
//         </div>
//         <div>
//           {!isPartner && <UsersListHeader label='Add new' />} 
//         </div>
//       </div>


//       <UsersTable columnProps={roleColumns(isFranchise, isSupplyChainManager)} />

//       <UserEditModal formName='UnitMeasurementModalForm' />
//     </KTCard>
//   )
// }

// const UserManagementWrapper = () => (
//   <QueryRequestProvider initialValue={{ type: 'CUSTOMER', status: 'ACTIVE' }}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <UserManagementList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )

// export { UserManagementWrapper }







































// import { ListViewProvider, useListView } from '../core/ListViewProvider'
// import { QueryRequestProvider } from '../core/QueryRequestProvider'
// import { QueryResponseProvider } from '../core/QueryResponseProvider'
// import { UsersListHeader } from '../components/header/UsersListHeader'
// import { UsersTable } from '../table/UsersTable'
// import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
// import { KTCard } from '../../../../../../_metronic/helpers'
// import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
// import { roleColumns } from './_columns'
// import { useAuth } from '../../../../auth'
// import { useState } from 'react'

// const mockedData = [
//   {
//     gender: 'Male',
//     email: 'ashok@gmail.com',
//     fullAddress: 'New Baneshwor, Kathmandu',
//     mobile: '9860105561',
//     joinDate: '2023/09/05',
//     currentLevel: 'Manager',
//     pointEarned: 45,
//     pointRedeemed: 5,
//     name: 'Ashok Karki',
//     birthday: '1992/12/22',
//   },
//   {
//     gender: 'Femal',
//     email: 'aleshika@gmail.com',
//     fullAddress: 'Old Baneshwor, Kathmandu',
//     mobile: '9860105560',
//     joinDate: '2023/09/06',
//     currentLevel: 'Employee',
//     pointEarned: 5,
//     pointRedeemed: 15,
//     name: 'Aleshki Chheri',
//     birthday: '1996/06/06',
//   },
// ]

// const SearchIcon = () => (
//   <svg
//     width='16'
//     height='16'
//     viewBox='0 0 24 24'
//     fill='none'
//     stroke='currentColor'
//     strokeWidth='2'
//     strokeLinecap='round'
//     strokeLinejoin='round'
//     style={{
//       position: 'absolute',
//       left: '10px',
//       top: '50%',
//       transform: 'translateY(-50%)',
//       color: '#6B7280',
//     }}
//   >
//     <circle cx='11' cy='11' r='8' />
//     <line x1='21' y1='21' x2='16.65' y2='16.65' />
//   </svg>
// )

// const UserManagementList = () => {

//   const [searchQuery, setSearchQuery] = useState('')
//   const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const query = e.target.value.toLowerCase()
//     setSearchQuery(query)

//     // Get all table rows
//     const tableRows = document.querySelectorAll('table tbody tr') as NodeListOf<HTMLTableRowElement>

//     // Loop through each row
//     tableRows.forEach((row: HTMLTableRowElement) => {
//       const cells = row.querySelectorAll('td') as NodeListOf<HTMLTableCellElement>
//       let found = false

//       // Check each cell in the row
//       cells.forEach((cell: HTMLTableCellElement) => {
//         const text = cell.textContent?.toLowerCase() || ''
//         if (text.includes(query)) {
//           found = true
//         }
//       })

//       // Show/hide row based on search match
//       if (found) {
//         row.style.display = ''
//       } else {
//         row.style.display = 'none'
//       }
//     })
//   }
//   const { isFranchise, isPartner, isSupplyChainManager } = useAuth()
//   return (
//     <KTCard>
//       {/* <div
//         style={{
//           position: 'relative',
//           width: '300px',
//           marginLeft: '30px',
//           marginBottom: '-30px',
//         }}
//       >
//         <SearchIcon />
//         <input
//           type='text'
//           placeholder='Search users...'
//           value={searchQuery}
//           onChange={handleSearch}
//           style={{
//             width: '100%',
//             height: '40px',
//             padding: '8px 8px 8px 35px',
//             fontSize: '14px',
//             border: '1px solid #E5E7EB',
//             borderRadius: '6px',
//             outline: 'none',
//             backgroundColor: 'white',
//             transition: 'border-color 0.2s ease',
//           }}
//           onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
//           onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
//         />
//       </div>
//       {!isPartner && <UsersListHeader label='Add new' />} */}

//       <div style={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         padding: "10px 30px"
//       }}>
//         <div
//           style={{
//             position: 'relative',
//             width: '300px',
//           }}
//         >
//           <SearchIcon />
//           <input
//             type='text'
//             placeholder='Search users...'
//             value={searchQuery}
//             onChange={handleSearch}
//             style={{
//               width: '100%',
//               height: '40px',
//               padding: '8px 8px 8px 35px',
//               fontSize: '14px',
//               border: '1px solid #E5E7EB',
//               borderRadius: '6px',
//               outline: 'none',
//               backgroundColor: 'white',
//               transition: 'border-color 0.2s ease',
//             }}
//             onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
//             onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
//           />
//         </div>
//         <div>
//           {!isPartner && <UsersListHeader label='Add new' />}
//         </div>
//       </div>


//       <UsersTable columnProps={roleColumns(isFranchise, isSupplyChainManager)} />

//       <UserEditModal formName='UnitMeasurementModalForm' />
//     </KTCard>
//   )
// }

// // const UserManagementWrapper = () => (
// //   <QueryRequestProvider initialValue={{ type: 'CUSTOMER', status: 'ACTIVE' }}>
// //     <QueryResponseProvider>
// //       <ListViewProvider>
// //         <UserManagementList />
// //       </ListViewProvider>
// //     </QueryResponseProvider>
// //   </QueryRequestProvider>
// // )



// const UserManagementWrapper = () => {
//   const getFranchiseId = () => {
//     const authData = localStorage.getItem('kt-auth-react-v');
//     if (authData) {
//       try {
//         const parsedData = JSON.parse(authData);
//         return parsedData.data?.franchises?.[0]?.id || '';
//       } catch (e) {
//         console.error('Error parsing auth data:', e);
//         return '';
//       }
//     }
//     return '';
//   };

//   return (
//     <QueryRequestProvider initialValue={{
//       type: 'CUSTOMER',
//       status: 'ACTIVE',
//       franchiseId: getFranchiseId()
//     }}>
//       <QueryResponseProvider>
//         <ListViewProvider>
//           <UserManagementList />
//         </ListViewProvider>
//       </QueryResponseProvider>
//     </QueryRequestProvider>
//   )
// }

// export { UserManagementWrapper }















import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider, useQueryRequest } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UsersTable } from '../table/UsersTable'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { roleColumns } from './_columns'
import { useAuth } from '../../../../auth'
import { useState } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'

const mockedData = [
  {
    gender: 'Male',
    email: 'ashok@gmail.com',
    fullAddress: 'New Baneshwor, Kathmandu',
    mobile: '9860105561',
    joinDate: '2023/09/05',
    currentLevel: 'Manager',
    pointEarned: 45,
    pointRedeemed: 5,
    name: 'Ashok Karki',
    birthday: '1992/12/22',
  },
  {
    gender: 'Femal',
    email: 'aleshika@gmail.com',
    fullAddress: 'Old Baneshwor, Kathmandu',
    mobile: '9860105560',
    joinDate: '2023/09/06',
    currentLevel: 'Employee',
    pointEarned: 5,
    pointRedeemed: 15,
    name: 'Aleshki Chheri',
    birthday: '1996/06/06',
  },
]

const SearchIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    style={{
      position: 'absolute',
      left: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#6B7280',
    }}
  >
    <circle cx='11' cy='11' r='8' />
    <line x1='21' y1='21' x2='16.65' y2='16.65' />
  </svg>
)

const UserManagementList = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const { updateState } = useQueryRequest()
  const { response } = useQueryResponse();
  console.log("response", response)

  const sortOptions = [
    { label: 'Activity', value: 'mostactive' },
    { label: 'Plastic prevented', value: 'mostlifetimecollected' },
    { label: 'Earning', value: 'mostlifetimepaid' },
    { label: 'Rewarded', value: 'mostlifetimeincentive' },
  ]

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase()
    setSearchQuery(query)

    // Get all table rows
    const tableRows = document.querySelectorAll('table tbody tr') as NodeListOf<HTMLTableRowElement>

    // Loop through each row
    tableRows.forEach((row: HTMLTableRowElement) => {
      const cells = row.querySelectorAll('td') as NodeListOf<HTMLTableCellElement>
      let found = false

      // Check each cell in the row
      cells.forEach((cell: HTMLTableCellElement) => {
        const text = cell.textContent?.toLowerCase() || ''
        if (text.includes(query)) {
          found = true
        }
      })

      // Show/hide row based on search match
      if (found) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSort = e.target.value
    updateState({
      customerSort: newSort
    })
  }

  const { isFranchise, isPartner, isSupplyChainManager, currentUser } = useAuth()

  const isMarketingUser = (currentUser as any)?.userType === 'CLIENT_USER' || (currentUser as any)?.userType === 'MARKETING';

  return (
    <KTCard>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px 30px",
        // borderBottom: "1px solid #EEF0F3"
      }}>
        <div style={{ position: 'relative', width: '320px' }}>
          <div style={{ position: 'absolute', top: '50%', left: '12px', transform: 'translateY(-50%)', color: '#A1A5B7', pointerEvents: 'none', display: 'flex' }}>
            <SearchIcon />
          </div>
          <input
            type='text'
            placeholder='Search users...'
            value={searchQuery}
            onChange={handleSearch}
            style={{
              width: '100%',
              height: '44px',
              padding: '8px 16px 8px 40px',
              fontSize: '14px',
              color: '#3F4254',
              border: '1px solid #E4E6EF',
              borderRadius: '8px',
              outline: 'none',
              backgroundColor: '#F9F9F9',
              transition: 'all 0.3s ease',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#3699FF';
              e.target.style.backgroundColor = '#FFFFFF';
              e.target.style.boxShadow = '0 0 0 3px rgba(54, 153, 255, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#E4E6EF';
              e.target.style.backgroundColor = '#F9F9F9';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <label style={{ fontWeight: '600', color: '#7E8299', fontSize: '13px' }}>Filter by</label>
            <div style={{ position: 'relative' }}>
              <select
                onChange={handleSortChange}
                style={{
                  padding: '10px 36px 10px 16px',
                  border: '1px solid #E4E6EF',
                  borderRadius: '8px',
                  backgroundColor: '#F9F9F9',
                  color: '#3F4254',
                  fontSize: '13px',
                  fontWeight: '500',
                  outline: 'none',
                  appearance: 'none',
                  cursor: 'pointer',
                  minWidth: '140px',
                  transition: 'all 0.3s ease',
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3699FF';
                  e.target.style.backgroundColor = '#FFFFFF';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#E4E6EF';
                  e.target.style.backgroundColor = '#F9F9F9';
                }}
              >
                {sortOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#A1A5B7' }}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          </div>

          {!isPartner && !isMarketingUser && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <UsersListHeader label='Add new' />
            </div>
          )}
        </div>
      </div>

      {/* Metrics Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', padding: '10px 30px' }}>

        {/* Card 1 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 11C14.7614 11 17 8.76142 17 6C17 3.23858 14.7614 1 12 1C9.23858 1 7 3.23858 7 6C7 8.76142 9.23858 11 12 11Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M2 22C2 17.5817 6.47715 14 12 14C17.5228 14 22 17.5817 22 22" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Total Plastic Keepers</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{response?.data?.length}</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
          </div>
        </div>

        {/* Card 2 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="8" r="3.5"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />

              <path d="M3.5 19C4.2 15.7 6.1 14 9 14C11.9 14 13.8 15.7 14.5 19"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />

              <path d="M15 16.5L17 18.5L21 14.5"
                stroke="#FFFFFF"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Active Keepers</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{(response?.data || [])?.filter((item) => item?.active)?.length}</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>{(((response?.data || [])?.filter((item) => item?.active)?.length / (response?.data || [])?.length) * 100).toFixed(2)}% of total</div>
          </div>
        </div>

        {/* Card 3 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="3.5"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />

              <path d="M5 19C5.8 15.7 8.3 14 12 14C15.7 14 18.2 15.7 19 19"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />

              <circle cx="18.5" cy="18" r="3"
                fill="#000000"
                stroke="#000000"
                stroke-width="1.5" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Inactive Keepers</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{(response?.data || [])?.filter((item) => !item?.active)?.length}</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>{(((response?.data || [])?.filter((item) => !item?.active)?.length / (response?.data || [])?.length) * 100).toFixed(2)}% of total</div>
          </div>
        </div>

        {/* Card 4 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="8" width="18" height="13" rx="2" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 8V21" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 8V5C12 3.89543 11.1046 3 10 3C8.89543 3 8 3.89543 8 5C8 6.65685 9.34315 8 11 8H12ZM12 8V5C12 3.89543 12.8954 3 14 3C15.1046 3 16 3.89543 16 5C16 6.65685 14.6569 8 13 8H12Z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Collected</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{response?.data?.reduce((acc, user) => acc + user.totalDepositedQuantity, 0)?.toFixed(2)}</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>Lifetime</div>
          </div>
        </div>

      </div>

      <UsersTable columnProps={roleColumns(isFranchise, isSupplyChainManager)} />

      <UserEditModal formName='UnitMeasurementModalForm' />
    </KTCard>
  )
}

const UserManagementWrapper = () => {
  const getFranchiseId = () => {
    const authData = localStorage.getItem('kt-auth-react-v');
    if (authData) {
      try {
        const parsedData = JSON.parse(authData);
        return parsedData.data?.franchises?.[0]?.id || '';
      } catch (e) {
        console.error('Error parsing auth data:', e);
        return '';
      }
    }
    return '';
  };

  return (
    <QueryRequestProvider initialValue={{
      type: 'CUSTOMER',
      status: 'ACTIVE',
      franchiseId: getFranchiseId(),
      customerSort: 'mostactive'
    }}>
      <QueryResponseProvider>
        <ListViewProvider>
          <UserManagementList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export { UserManagementWrapper }